var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobe2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 178,
    viewBox: "0 0 178 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_72_468)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.05176e-05 89.0104C-0.0110168 100.702 2.28391 112.28 6.75333 123.083C11.2228 133.886 17.7789 143.702 26.0465 151.967C34.3141 160.233 44.1308 166.787 54.9346 171.254C65.7383 175.721 77.317 178.014 89.0078 178C90.586 178 92.1825 177.963 93.7425 177.87H93.7608C96.0903 177.757 98.399 177.53 100.674 177.249C117.429 175.055 133.206 168.105 146.135 157.224C154.474 150.205 161.481 141.741 166.819 132.237C167.362 131.262 167.889 130.265 168.416 129.269C168.416 129.232 168.434 129.214 168.452 129.175C168.997 128.105 169.496 127.033 169.994 125.945H170.012C171.569 122.529 172.899 119.014 173.996 115.424C174.827 112.806 175.523 110.146 176.083 107.457C176.097 107.435 176.104 107.41 176.101 107.384C176.495 105.485 176.834 103.57 177.097 101.645C177.702 97.4604 178.004 93.2381 178 89.0104C178 86.5478 177.906 84.0877 177.682 81.6825C177.57 80.1433 177.4 78.6198 177.194 77.0989C176.067 68.5068 173.667 60.1304 170.072 52.2454C163.001 36.6734 151.597 23.4663 137.222 14.2018C122.848 4.93725 106.109 0.00698986 89.0078 0C88.0687 0 87.1295 0.0182612 86.2087 0.0365225C85.2122 0.0756536 84.2157 0.112176 83.2218 0.18783C78.1886 0.513975 73.1924 1.26802 68.2871 2.44179C65.4698 3.1305 62.6967 3.91312 60.002 4.84705C58.1603 5.46793 56.3498 6.15142 54.5733 6.91318C53.2403 7.47667 51.9438 8.05842 50.6473 8.6793C50.4203 8.79148 50.196 8.88539 49.9716 8.99757C41.3813 13.2005 33.5228 18.7576 26.6971 25.4562C25.7215 26.3953 24.7823 27.371 23.8276 28.3675C23.2093 29.0432 22.5885 29.7397 22.0015 30.4336C20.958 31.5997 19.972 32.8206 18.9963 34.0415C11.2192 43.9282 5.63396 55.3561 2.61125 67.5665C0.871353 74.5816 -0.0055542 81.7828 -3.05176e-05 89.0104Z",
    fill: "url(#paint0_radial_72_468)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9744 9.00539C50.2704 9.0296 50.5648 9.07053 50.8562 9.12801C51.7833 9.29755 52.738 9.2339 53.6344 8.94278C54.344 8.74191 54.8526 8.44973 55.6092 8.32451C56.6891 8.15494 57.6961 7.69319 58.7735 7.54189C59.9161 7.38797 60.9048 6.93927 61.9847 6.55317C62.8352 6.24534 63.2891 6.35491 64.1004 6.55317C64.9117 6.75144 65.4908 6.43056 66.216 6.12273C67.0325 5.76794 67.8517 5.70533 68.7151 5.53576C70.9716 5.0714 73.2099 4.34617 75.4481 3.77486C76.8359 3.42007 78.1194 3.42007 79.5385 3.40441C80.6498 3.38876 81.6541 3.71486 82.7654 3.71486C83.4754 3.69028 84.1826 3.61267 84.8811 3.48268C85.635 3.34441 86.4071 3.49833 87.1636 3.38876C88.2906 3.21919 88.8932 3.04962 90.0332 3.40441C90.8836 3.68355 91.5462 3.65225 92.3966 3.6992C93.3873 3.78784 94.3684 3.96241 95.3288 4.22095C97.0275 4.64774 98.7712 4.86933 100.523 4.88096C101.566 4.88096 103.116 4.58879 104.12 4.94357C104.77 5.17575 105.093 5.86968 105.542 6.33404C106.405 7.22884 107.47 8.03233 108.195 9.03409C108.92 10.0358 109.739 11.0741 109.676 12.3394C109.616 13.435 109.108 14.7159 108.633 15.7307C108.14 16.7951 107.97 17.7682 109.066 18.4778C110.461 19.4317 111.991 20.1704 113.605 20.6691C114.649 20.9795 115.596 21.1648 116.475 20.4082C116.801 20.1291 116.996 19.5891 117.401 19.3647C117.805 19.1404 118.251 19.3647 118.705 19.5056C119.793 19.8649 120.901 20.1585 122.023 20.3847C122.717 20.4917 123.328 20.8621 123.998 20.9874C124.817 21.1413 125.404 20.5387 126.252 20.7265C127.442 21.0056 128.631 21.5091 129.865 21.5613C130.744 21.6056 131.858 21.2195 132.599 20.7787C133.029 20.5178 133.139 20.283 133.642 20.4239C134.125 20.6017 134.548 20.9118 134.863 21.3187C135.155 21.7361 135.262 22.2761 135.557 22.7091C135.865 23.1865 136.16 23.6509 136.436 24.1596C136.948 25.1362 137.537 26.0705 138.197 26.9536C138.659 27.5718 138.98 28.404 139.501 28.9753C139.762 29.2858 140.336 29.4971 140.675 29.7319C141.601 30.3815 142.574 30.9684 143.469 31.6624C145.199 33.0215 146.834 34.532 148.595 35.8363C149.936 36.8381 151.82 37.4251 153.348 38.059C154.306 38.4451 155.294 38.7216 156.252 39.1234C156.559 39.2486 157.131 39.3842 157.394 39.619C157.733 39.9112 157.916 40.4512 158.226 40.853C159.061 41.873 159.94 42.8904 160.574 44.0643C160.926 44.7377 161.209 45.4448 161.419 46.1748C161.759 47.1766 162.301 48.1027 162.64 49.107C163.334 51.2071 163.472 53.3984 164.245 55.4828C164.693 56.7037 165.34 57.815 165.896 58.9264C166.853 60.8099 166.994 63.0482 167.271 65.1326C167.416 66.4031 167.374 67.688 167.148 68.9466C166.916 70.2275 166.979 71.5553 166.994 72.8597C167.01 74.2475 167.889 75.6067 168.768 76.658C169.572 77.6285 170.79 77.9989 171.687 78.865C172.444 79.6059 173.354 80.4537 173.678 81.5051C173.816 81.9668 173.693 82.4912 173.769 82.9868C173.97 84.0825 174.249 85.1182 174.403 86.2295C174.557 87.5813 174.626 88.9414 174.609 90.3018C174.609 90.9957 174.656 91.7053 174.625 92.4018C174.593 93.0983 174.345 93.6827 174.301 94.3453C174.27 94.8097 174.361 95.2714 174.301 95.7358C174.207 96.2575 174.006 96.8002 173.884 97.301C173.576 98.535 173.344 99.7402 173.101 100.974C172.885 102.117 172.438 103.244 172.081 104.366C171.61 105.889 171.239 107.441 170.97 109.012C170.74 110.186 170.756 111.407 170.584 112.594C170.445 113.551 170.229 114.524 170.185 115.481C170.138 116.932 170.492 118.385 170.508 119.851C170.524 122.322 169.535 124.789 168.964 127.169C168.794 127.831 168.625 128.512 168.442 129.175C175.299 115.603 178.566 100.502 177.931 85.3098C177.296 70.1177 172.781 55.3413 164.816 42.3893C156.851 29.4372 145.701 18.7412 132.43 11.3208C119.158 3.90043 104.208 0.00298053 89.0027 0C87.0567 0 85.1419 0.0626099 83.2272 0.185221C71.6712 0.912672 60.3718 3.9098 49.9744 9.00539Z",
    fill: "url(#paint1_linear_72_468)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.336 120.671C126.57 116.194 128.122 110.88 129.75 105.54C128.451 110.82 126.967 115.923 125.336 120.671Z",
    fill: "url(#paint2_linear_72_468)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.992 169.235C127.992 169.235 124.462 142.026 121.778 142.026C119.691 142.026 116.13 146.132 108.93 151.602C106.919 153.131 104.639 154.759 102.007 156.441C99.3513 158.082 96.6004 159.563 93.7687 160.876C88.4679 163.396 82.3323 165.888 76.8124 167.993C68.0733 171.322 60.8499 173.69 60.8499 173.69L59.4491 172.684C64.3711 171.57 69.2281 170.187 73.9976 168.538C73.9976 168.538 65.3055 154.407 54.203 141.655C43.1005 128.904 0.464417 98.9134 0.464417 98.9134L0.101807 94.6768C0.101807 94.6768 12.2713 104.741 25.7607 115.44C25.7607 115.416 16.7373 53.4377 13.8834 43.5401L16.7373 42.3636C16.7373 42.3636 23.4364 103.494 30.9102 119.481C43.7788 129.574 56.6056 139.174 60.3021 140.379C68.4151 143.025 98.1513 119.139 98.1904 119.108C98.96 94.5203 98.3913 67.1154 96.3644 59.9648C66.0386 31.2634 36.9962 16.957 36.9962 16.957L38.371 15.5796C38.371 15.5796 67.3272 35.9278 68.1672 32.0382C69.0072 28.1485 49.9065 8.50466 49.9065 8.50466L52.0691 8.19161C52.0691 8.19161 73.3141 35.4347 102.636 64.2536C123.27 84.5235 130.178 90.6671 132.466 92.5324C136.191 71.2268 136.441 48.8802 130.181 34.4539C118.449 7.42464 102.2 1.2393 102.2 1.2393C104.856 1.1506 110.535 2.58541 110.535 2.58541C110.535 2.58541 118.674 12.2378 122.115 17.8544C125.555 23.471 130.181 34.4539 132.935 32.706C135.69 30.9581 144.153 19.2292 144.153 19.2292L145.175 20.2518C145.175 20.2518 137.01 27.8824 135.625 33.7965C134.24 39.7105 135.453 75.9982 139.131 74.6546C142.809 73.3111 169.235 50.8003 169.235 50.8003L170.125 52.7203C170.125 52.7203 142.585 71.5502 139.131 78.1843C137.42 81.4609 133.392 93.5759 129.761 105.529C130.175 103.836 131.519 97.896 130.932 95.2951C121.653 81.5626 111.249 74.6364 100.828 64.3005C98.5635 77.0234 98.6496 121.902 98.8452 144.206L109.087 149.301C112.095 146.492 114.732 143.408 116.754 140.012C119.832 134.849 122.754 128.197 125.347 120.67C123.755 126.441 122.691 130.824 122.67 132.084C122.595 136.518 129.432 168.517 129.432 168.517L127.992 169.235ZM25.9798 115.602C27.545 116.842 29.1198 118.083 30.7041 119.327L25.9798 115.602ZM98.1565 120.146L98.0991 121.933C98.12 121.341 98.1383 120.743 98.1565 120.146ZM98.0913 122.131C98.0652 122.147 69.5707 139.871 64.8438 143.085C60.4638 146.066 74.4359 164.873 76.5228 167.646C82.6347 165.473 88.5697 162.831 94.2748 159.744C96.1844 154.555 97.4704 139.307 98.0913 122.131ZM98.8374 144.467V144.298C98.8348 144.355 98.8348 144.41 98.8374 144.467ZM98.8374 145.941C98.9026 152.667 98.9704 156.961 98.9704 156.976C102.035 155.063 104.947 152.916 107.681 150.554C105.818 149.027 102.114 146.351 98.8504 145.941H98.8374Z",
    fill: "url(#paint3_linear_72_468)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.967 113.501C154.058 107.452 177.87 86.0234 177.87 86.0234L177.891 91.6818C177.891 91.6818 156.322 104.433 150.471 115.009C144.62 125.585 150.781 153.256 150.781 153.256L148.47 155.565C148.47 155.565 144.009 122.308 149.967 113.501Z",
    fill: "url(#paint4_linear_72_468)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.779 158.518C151.033 150.771 158.622 141.228 164.085 130.466C167.576 123.592 170.149 116.289 171.739 108.746C171.753 108.722 171.759 108.694 171.755 108.667C173.015 102.625 173.65 96.469 173.651 90.2966C173.649 66.692 164.27 44.0554 147.577 27.3662C130.885 10.677 108.247 1.30231 84.6435 1.30438C82.6974 1.30438 80.7853 1.36699 78.8705 1.4896C72.9399 1.87277 67.0628 2.84985 61.3272 4.40618C68.4198 2.08114 75.7783 0.66375 83.227 0.18784C85.1313 0.0652285 87.0565 9.79908e-06 89.0026 9.79908e-06C100.692 -0.0054767 112.268 2.293 123.068 6.76406C133.869 11.2351 143.682 17.7911 151.947 26.0571C160.213 34.3232 166.768 44.1372 171.238 54.9383C175.708 65.7394 178.006 77.3156 178 89.0052C177.999 95.1778 177.363 101.334 176.101 107.376C176.105 107.403 176.099 107.431 176.085 107.454C174.5 114.998 171.931 122.3 168.444 129.175C162.794 140.304 154.873 150.126 145.193 158.006C135.514 165.887 124.29 171.651 112.246 174.927C123.049 171.398 133.075 165.827 141.779 158.518Z",
    fill: "url(#paint5_radial_72_468)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.609 2.13102C108.609 2.13102 101.07 82.8691 98.853 89.7327C96.6356 96.5963 76.5227 109.189 68.3002 110.731C60.0777 112.272 39.2214 119.861 33.7823 119.642C28.3432 119.423 4.66431 117.461 4.66431 117.461L1.39304 104.78C1.39304 104.78 45.5683 70.6367 61.2124 39.4048C76.8566 8.17287 76.5019 0.857948 76.5019 0.857948L83.227 0.1875C83.227 0.1875 66.2707 32.8386 61.3272 48.7337C56.3838 64.6288 35.3553 80.3178 25.9798 89.451C16.6042 98.5842 19.3146 114.659 30.704 113.874C42.0935 113.089 81.0514 115.317 90.6748 85.9187C94.8643 73.1228 98.5686 60.6791 101.417 39.3917C104.266 18.1044 108.609 2.13102 108.609 2.13102Z",
    fill: "url(#paint6_radial_72_468)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.45 64.0705C174.45 64.0705 144.012 75.7656 132.385 83.6361C120.758 91.5067 89.4331 100.572 82.7836 107.431C76.1341 114.289 64.9716 127.176 65.9368 133.273C66.902 139.369 106.371 135.044 122.104 129.174C137.837 123.305 164.174 111.247 167.74 105.529C171.306 99.8104 177.703 96.2964 177.703 96.2964L176.683 104.297C176.683 104.297 137.367 130.147 132.147 132.302C126.927 134.457 73.1341 144.433 58.0612 141.694C58.0612 141.694 50.9995 135.649 77.1045 109.799C87.5887 99.4165 106.41 90.9798 123.8 83.0413C149.696 71.2185 173.826 62.0879 173.826 62.0879L174.45 64.0705Z",
    fill: "url(#paint7_radial_72_468)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3803 2.92192C66.3803 2.92192 64.3299 25.9806 56.7648 44.9671C49.1996 63.9535 34.685 67.1753 28.3303 74.185C21.9755 81.1947 5.36612 90.5236 8.39233e-05 86.8088L0.467049 101.48C0.467049 101.48 59.9473 77.7669 76.502 0.858398L66.3803 2.92192Z",
    fill: "url(#paint8_radial_72_468)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.371 142.177C160.371 142.177 135.085 135.303 104.141 139.939C64.0769 145.939 55.737 148.939 52.1787 153.21C48.6205 157.48 47.3057 167.646 47.3057 167.646L42.9362 165.142C42.9362 165.142 45.1666 145.378 49.9796 142.185C54.7926 138.992 92.5244 145.576 132.153 132.313L165.353 134.76L160.371 142.177Z",
    fill: "url(#paint9_radial_72_468)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9267 118.142C43.6353 113.577 68.4907 107.506 72.5942 110.811C75.9855 113.543 53.8118 139.247 48.3805 139.917C42.9493 140.588 40.218 122.705 41.9267 118.142ZM50.9918 132.302C57.3987 131.097 72.0177 116.141 68.7881 113.099C66.1142 110.579 46.2466 117.138 44.8223 120.845C43.3979 124.552 44.5849 133.51 50.9918 132.302Z",
    fill: "url(#paint10_radial_72_468)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4321 91.0291C98.386 84.2099 108.609 2.13086 108.609 2.13086L110.54 2.58217C110.54 2.58217 94.4104 82.9811 107.931 85.2612C118.577 87.056 173.229 60.1833 173.229 60.1833L174.45 64.0703C174.45 64.0703 106.408 85.2246 81.0462 107.43C72.4063 114.996 64.9846 123.68 59.0499 131.984C58.4209 132.859 58.0448 133.89 57.9626 134.964C57.8804 136.038 58.0954 137.115 58.5841 138.075C59.0727 139.035 59.8161 139.843 60.7329 140.409C61.6497 140.975 62.7046 141.277 63.782 141.284C133.59 141.827 176.696 104.292 176.696 104.292L176.114 107.373C176.114 107.373 133.47 129.899 137.735 132.302C142 134.705 166.832 132.226 166.832 132.226L165.369 134.765C165.369 134.765 145.381 133.093 119.681 136.661C97.9843 139.648 61.3142 144.195 50.3813 145.547C44.6891 155.616 42.0022 163.396 42.9413 165.141L38.6944 162.417C45.7222 142.805 44.1231 120.805 33.7927 119.634C23.4624 118.463 6.38344 122.131 6.38344 122.131L4.67476 117.453C61.6794 120.166 94.4782 97.8666 96.4321 91.0291ZM99.1556 93.6379C100.828 93.6953 107.159 88.9969 106.408 88.2456C105.75 87.5882 101.662 78.6741 100.348 79.8767C99.033 81.0794 97.5043 93.5831 99.1556 93.6535V93.6379ZM135.356 132.302C135.356 132.302 134.999 131.026 134.399 130.781C133.799 130.536 122.188 134.577 122.884 135.046C123.581 135.516 135.356 133.75 135.356 132.302ZM46.9509 137.376C51.2343 137.037 77.0654 112.854 72.5941 110.811C69.362 109.327 46.1239 114.85 44.1126 119.321C42.1013 123.792 42.6857 137.694 46.9509 137.376Z",
    fill: "url(#paint11_linear_72_468)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.8706 1.47894C78.8706 1.47894 72.7272 27.9264 48.4431 60.7992C24.159 93.672 1.3931 104.78 1.3931 104.78L0.461807 98.9026C0.461807 98.9026 21.3312 95.5425 45.7953 63.061C74.4072 25.0933 74.175 1.23633 74.175 1.23633L78.8706 1.47894Z",
    fill: "url(#paint12_linear_72_468)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.535 80.5321C174.332 98.6525 133.274 69.0537 93.6565 55.7908C47.1335 40.2114 12.1199 73.4468 6.96519 71.5946C-1.10081 68.6963 31.591 2.54366 84.5236 3.70455C144.158 5.00893 177.478 51.2855 175.535 80.5321Z",
    fill: "url(#paint13_linear_72_468)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.348 65.5392C168.418 68.9305 160.084 65.8601 152.286 55.8868C144.489 45.9136 138.768 23.2462 141.249 20.6687C143.73 18.0913 167.858 42.0187 168.348 65.5392Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.823 70.4125C172.814 70.3499 174.241 77.8579 172.441 81.5727C170.641 85.2876 167.224 84.3902 165.684 77.8631C164.743 73.843 165.528 70.4647 168.823 70.4125Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.943 164.218C129.943 164.218 87.7061 178.929 47.3657 156.624C7.0252 134.319 0.380905 84.002 0.380905 84.002C0.380905 84.002 5.33738 143.176 44.2822 162.058C83.227 180.94 112.384 175.133 129.943 164.218Z",
    fill: "url(#paint14_radial_72_468)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_72_468",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.119 47.3774) rotate(180) scale(157.311 157.315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FF7263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FC6F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F46562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E55560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D03D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B6205A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#9A0057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9A00AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_72_468",
    x1: 178,
    y1: 64.59,
    x2: 49.9744,
    y2: 64.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FF9D85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FF9A84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF917F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF8178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FF6A6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_72_468",
    x1: 124.873,
    y1: 110.434,
    x2: 130.238,
    y2: 115.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FF9D85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FF9A84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF917F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF8178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FF6A6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_72_468",
    x1: 29.9036,
    y1: 24.072,
    x2: 151.9,
    y2: 146.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FF9D85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FF9A84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF917F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF8178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FF6A6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_72_468",
    x1: 152.548,
    y1: 110.173,
    x2: 173.219,
    y2: 130.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FF9D85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FF9A84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF917F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF8178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FF6A6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D61"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_72_468",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.039 28.4275) rotate(180) scale(117.142 117.146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_72_468",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.5439 90.291) rotate(180) scale(64.4028 64.4047)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#623964"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_72_468",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.3914 127.004) rotate(180) scale(65.775 65.7769)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#623964"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_72_468",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3563 76.7521) rotate(180) scale(48.3413 48.3427)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#623964"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_72_468",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.9087 158.962) rotate(180) scale(63.5707 63.5725)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#623964"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_72_468",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.0588 134.24) rotate(180) scale(19.0433 19.0439)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#623964"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_72_468",
    x1: 176.685,
    y1: 83.6359,
    x2: 4.66432,
    y2: 83.6359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFBB85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FEB887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F9AF8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F19F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E588A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#D76BB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#C547C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B01EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A100EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_72_468",
    x1: 78.8706,
    y1: 53.0069,
    x2: 0.467023,
    y2: 53.0069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FF9D85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FD9A87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F8918D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#EE8198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#E16AA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CF4DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#BA2AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A100EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_72_468",
    x1: 141.437,
    y1: 18.1649,
    x2: 41.9194,
    y2: 109.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FF9346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#BB6C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#794621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#452813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1F1209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#080502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_72_468",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5526 157.449) rotate(180) scale(56.1386 56.1402)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5ED9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178,
    height: 178,
    fill: "white",
    transform: "matrix(-1 0 0 1 178 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe2);
export default __webpack_public_path__ + "static/media/globe 2.46b421934a825e6c702b96081a5a7f66.svg";
export { ForwardRef as ReactComponent };